import React from "react";
import HeroSection from "../components/Research/HeroSection";
import ResearchTabsSection from "../components/Research/ResearchTabsSection";
import JoinUsSection from "../components/Research/JoinUsSection";
import NavBar from "../components/NavBar/NavBar";

export default function ResearchPage() {
  return (
    <div className="min-h-screen">
      <main className="flex-1">
        <NavBar />
        <HeroSection />
        <ResearchTabsSection />
        <JoinUsSection />
      </main>
    </div>
  );
}
